import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ReactPlayer from 'react-player';

import {
    initiateVideo,
    playVideo,
    pauseVideo,
    videoCompleted
} from '../../containers/Video/actions';

import { getActionCompletedTime } from '../../utils/actionTiming';
import { isPortrait } from '../../utils/size';

const VideoContainer = styled.div`
    position: relative;
    width: 100%;
    margin-top: ${() => (isPortrait() ? '10%' : 0)};
    > div {
        display: flex;
        justify-content: center;
        width: 100% !important;
        height: 100% !important;
    }
`;

const getAvailableVideoSpace = () => {
    const actionContentWrapper = document.querySelector('#videoContainer');
    if (!actionContentWrapper) {
        return 180;
    }
    return actionContentWrapper.offsetHeight;
};

class Video extends Component {
    render() {
        return (
            <VideoContainer>
                <ReactPlayer
                    progressInterval={100}
                    style={{
                        width: `460px`,
                        height: isPortrait() ? `260px` : `${getAvailableVideoSpace()}px`
                    }}
                    url={this.props.url}
                    playing={this.props.autoplay}
                    volume={1}
                    muted={this.props.muted ? false : true}
                    loop={true}
                    controls={true}
                    onStart={() =>
                        this.props.initiateVideo(
                            this.props.actionIdentifier,
                            this.props.actionInitated,
                            this.props.engaged
                        )
                    }
                    onEnded={() => {
                        // ONLY FIRES IF COMPONENT PROP LOOP === FALSE
                        if (!this.props.videoAlreadyCompleted) {
                            this.props.videoCompleted(
                                this.props.apiRequestData,
                                this.props.actionCompletedTime(),
                                this.props.actionIdentifier,
                                this.props.actionCompleted
                            );
                        }
                    }}
                    onProgress={d => {
                        if (d.played > 0.9 && !this.props.videoAlreadyCompleted) {
                            this.props.videoCompleted(
                                this.props.apiRequestData,
                                this.props.actionCompletedTime(),
                                this.props.actionIdentifier,
                                this.props.actionCompleted
                            );
                        }
                    }}
                    onPlay={() => this.props.playVideo()}
                    onPause={() => this.props.pauseVideo()}
                />
            </VideoContainer>
        );
    }
}

Video.propTypes = {
    actionCompleted: PropTypes.bool.isRequired,
    actionCompletedTime: PropTypes.func.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    actionInitated: PropTypes.bool.isRequired,
    apiRequestData: PropTypes.object.isRequired,
    autoplay: PropTypes.bool.isRequired,
    engaged: PropTypes.bool.isRequired,
    initiateVideo: PropTypes.func.isRequired,
    muted: PropTypes.bool.isRequired,
    pauseVideo: PropTypes.func.isRequired,
    playVideo: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired,
    videoAlreadyCompleted: PropTypes.bool.isRequired,
    videoCompleted: PropTypes.func.isRequired
};

export default connect(
    state => {
        return {
            actionIdentifier: state.widget.activeAction.identifier,
            apiRequestData: state.widget.apiRequestData,
            actionCompletedTime: getActionCompletedTime(state, 'video'),
            actionInitated: state.video.actionInitated,
            actionCompleted: state.video.actionCompleted,
            engaged: state.widget.engaged,
            videoAlreadyCompleted:
                state.video.videosCompleted.length > 0
                    ? state.video.videosCompleted.includes(
                          state.widget.activeAction.identifier
                      )
                    : false
        };
    },
    {
        initiateVideo,
        playVideo,
        pauseVideo,
        videoCompleted
    }
)(Video);
